export enum SimulationsTab {
  LIBRARY = 'library',
  FAVORITES = 'my-favorites',
  DRAFTS = 'my-drafts',
  FYP = 'for-you',
}
